import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input, OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import {NzModalRef, NzSelectComponent} from 'ng-zorro-antd';
import {HttpClient} from '@angular/common/http';
import {debounceTime, exhaustMap, map, switchMap, takeUntil, timeout} from 'rxjs/operators';
import {fromEvent, interval, of, Subscription} from 'rxjs';
import {CategoryInfoDto} from './DTO/category-info.dto';
import {ModalCategoryService} from '../service/modal-category.service';

@Component({
  selector: 'app-modal-category',
  templateUrl: './modal-category.component.html',
  styleUrls: ['./modal-category.component.scss']
})
export class ModalCategoryComponent  implements OnInit, AfterViewInit , OnDestroy {
  @Input() apiSearch: string;
  @Input() apiDetail: string;
  @Input() categoriesParent;
  @Output() valueChange = new EventEmitter();
  @ViewChild('selectInput' , {static: true}) selectInput: NzSelectComponent;
  categories: CategoryInfoDto[];
  categoriesShow: CategoryInfoDto[];
  value = '';
  category = {};
  checkSubmit = true;
  checkLevel = [];
  currentSelect: CategoryInfoDto;
  lstCategoryIdHighLight = [];
  lstCategoryIdHighLightId = [];
  lstCategoryIdHighLightName = '';
  subcriptionArr: Subscription[] = [];
  constructor(public modalRef: NzModalRef, private modalService: ModalCategoryService) {

  }

  ngOnInit() {
    const keyword = '';
    if (this.categoriesParent.length === 0) {
      const sub =   this.modalService.getApiDetail(0).pipe(map((z: any) => {
        this.categories  = z.listCategorys  as CategoryInfoDto[];
        this.checkLevel =  this.executeLevelCategory(this.categories);
      })).subscribe();
      this.subcriptionArr.push(sub);
    } else {
      console.log('categoriesParent', this.categoriesParent);
      const lastValueName = this.categoriesParent[this.categoriesParent.length - 1].name;
      this.lstCategoryIdHighLightName = lastValueName.includes('->') ? lastValueName :  this.categoriesParent.map(z => z.name).join(' -> ');
      const sub = this.modalService.getApiDetail(`${ this.categoriesParent[this.categoriesParent.length - 1 ].id}`).pipe(map(this.getDetail)).subscribe();
      this.subcriptionArr.push(sub);
    }



  }
  submit() {
    this.modalRef.close(this.lstCategoryIdHighLight);
  }
  clickCategory(category: CategoryInfoDto) {
    const {id, level, name, parentId, hasChild} = category;
    this.checkSubmit = hasChild;
    this.selectInput.writeValue(undefined);
    const length = this.lstCategoryIdHighLight.length;

    if (length === level) {
      this.lstCategoryIdHighLight.splice(level - 1, 1, {id, name, parentId});

    } else if (length > level) {

      this.checkLevel.splice((length - level) * -1);

      this.lstCategoryIdHighLight.splice(level - 1, length - level + 1 );
      this.lstCategoryIdHighLight.push({id, name, parentId});

    } else {

      this.lstCategoryIdHighLight.push({id, name, parentId});
    }
    this.lstCategoryIdHighLightId = this.lstCategoryIdHighLight.map(z => z.id);

    this.lstCategoryIdHighLightName = this.lstCategoryIdHighLight.map(z => z.name).join(' -> ');


    if (!category.hasChild) {
      const a = [];
      for (let i = 1; i <= level; i++) {
        a.push(i);
      }
      console.log(a);
      this.checkLevel = [...a];
    } else {

      const a = [];
      for (let i = 1; i <= level + 1; i++) {
        a.push(i);
      }
      this.checkLevel = [...a];
      const sub = this.modalService.getApiDetail(`${category.id}`).pipe(switchMap((z: any) => {
        this.categories = z.listCategorys
        return this.modalService.getChildrenById(category.id).pipe(map((q: any) => {
          return q.listCategorys
        }));
      })).subscribe((z: any) => {
        console.log(z);
        this.categories.push(...z);
      });
      this.subcriptionArr.push(sub);

    }


  }
// when search change value
  onChanges(value: any) {
    this.currentSelect = value;
    if(!value.hasChild){
      this.checkSubmit = false
    }
    this.lstCategoryIdHighLightName = value.name;
    this.lstCategoryIdHighLight = [];
    this.categories = [];
    const sub = this.modalService.getApiDetail(`${value.id}`).pipe(map(this.getDetail)).subscribe((z) => {
    });
    this.subcriptionArr.push(sub);
  }

  searchCategory(value) {

    this.value = value;
  }

  getDetail = (z) => {
    const category =  this.currentSelect || this.categoriesParent[this.categoriesParent.length - 1];
    this.categories  = z.listCategorys
    this.checkListCategoryHighLight(category);
    this.checkLevel = this.executeLevelCategory(this.categories);
    this.lstCategoryIdHighLight.reverse();
    this.lstCategoryIdHighLightId = this.lstCategoryIdHighLight.map( q => q.id);
    const test = interval(1000).pipe( switchMap( (q: any) => of( this.lstCategoryIdHighLightId ))).subscribe( lstID => {
      lstID.forEach((id, index) => {

        const element = document.getElementById(`group_high_light${id}`);
        const groupElement = document.getElementById(`group${index + 1}`);

        if (element && groupElement) {
          const top = element.offsetTop
          const top1 = groupElement.offsetTop;

          if(top > 0){
            groupElement.scroll({top: top - top1, left: 0, behavior: 'auto'});
          }
        }
      });
      test.unsubscribe()

    });
    // const a = setInterval(() => {
    //   if(document.getElementById(`group_high_light${this.lstCategoryIdHighLightId[0]}`)){
    //     console.log(document.getElementById(`group_high_light${this.lstCategoryIdHighLightId[0]}`))
    //     clearInterval(a);
    //   }
    // } , 1000)
    return z;
  }

  ngAfterViewInit(): void {
    setTimeout( () => {
      fromEvent(document.querySelector('#category'), 'keyup').pipe(exhaustMap(() => {
            return   this.modalService.getApiSearch(this.value).pipe(map((z: any) => {
              this.categoriesShow  = z.data.items;
              // this.checkLevel = this.executeLevelCategory(this.categories);

            }));
          }
        ),
        debounceTime(500)).subscribe();
    } , 1000);
  }



  executeLevelCategory(categories: CategoryInfoDto[]) {
    return [... new Set(categories.map(z => z.level))].sort((a, b) => a - b);
  }

  checkListCategoryHighLight(currentValue: CategoryInfoDto) {
    this.lstCategoryIdHighLight.push({id: currentValue.id, name: currentValue.name, parentId: currentValue.parentId});
    this.lstCategoryIdHighLight  = [... new Set(this.lstCategoryIdHighLight)];
    this.categories.forEach(z => {
      if (!currentValue.parentId) { return; }
      if ( z.id === currentValue.parentId) {
        this.checkListCategoryHighLight(z);
      }
    });
  }

  ngOnDestroy(): void {
    this.subcriptionArr.forEach((sub) => {
      sub.unsubscribe();
    });

  }
}
